import styled, {css} from "styled-components"

import Close from "@irati/ui/src/Close"
import {H2, H4} from "@irati/ui/src/Typography"
import media from "@irati/ui/src/global/media"
import {breakWord} from "@irati/ui/src/global/helpers"
import BrandAvatar from "@irati/ui/src/BrandAvatar"

export const padding = css`
  padding-bottom: ${({theme}) => theme.spacing.four};
`

export const DealAvatar = styled(BrandAvatar)`
  position: absolute;
  transform: translate3d(-50%, 0, 0);
`

export const InstructionHeader = styled(H4)`
  ${padding}
  font-weight: bold;
  ${media.tablet`
    font-weight: 400;
    font-size: 15px;
    padding-bottom: 15px;
  `}
`
export const PopupHeader = styled(H2)`
  ${padding};
  ${breakWord};
  overflow-wrap: break-word;
  ${media.tablet`
    font-size: 30px;
    line-height: 40px;
    padding-top: 20px;
    padding-bottom: 25px;
  `}
`

export const StyledClose = styled(Close)`
  z-index: 9;
`
